import moment from 'moment';
export function truncateString(str, num) {
  if (str.length <= num) {
    return str;
  }
  return str.slice(0, num) + '...';
}
export function formatDate(date) {
  var splitDateAndTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!date) return '-';
  var utcDate = moment.utc(date, 'DD/MM/YYYY HH:mm:ss');
  if (utcDate.local().format('DD/MM/YYYY HH:mm') === 'Invalid date') {
    utcDate = moment.utc(moment(date), 'DD/MM/YYYY HH:mm:ss');
  }
  if (splitDateAndTime) {
    return {
      date: utcDate.local().format('DD/MM/YYYY'),
      time: utcDate.local().format('HH:mm')
    };
  }
  return utcDate.local().format('DD/MM/YYYY HH:mm');
}
export function blogImageUrls(imagesArray) {
  var blogImages = imagesArray.length > 0 ? imagesArray.map(function (image) {
    return {
      original: image.source,
      thumbnail: image.source,
      fullscreen: image.source
    };
  }) : [{
    original: 'https://storage.googleapis.com/reactive_files_eu/no-image.jpg',
    thumbnail: '',
    fullscreen: ''
  }];
  return blogImages;
}
export function getTranslation(translations, currentLocale, defaultLocale) {
  var currentTranslation = translations.find(function (t) {
    return t.locale === currentLocale;
  });
  if (currentTranslation) {
    return currentTranslation;
  }
  var defaultTranslation = translations.find(function (t) {
    return t.locale === defaultLocale;
  });
  return defaultTranslation || translations[0];
}
export function validateEmail(email) {
  var re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g;
  return re.test(email);
}
export function validatePhoneNumber(phoneFieldValue) {
  var re = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
  return re.test(phoneFieldValue);
}
export function prefixLink(item, appProps) {
  if (item.translations.filter(function (t) {
    return t.locale;
  })) {
    var blogArchiveTranslation = appProps.blogArchive ? appProps.blogArchive.translations.filter(function (t) {
      return t.locale === appProps.currentLocale;
    })[0] : null;
    var itemTranslation = item.translations.filter(function (t) {
      return t.locale === appProps.currentLocale;
    })[0];
    var localePrefix = appProps.currentLocale ? "/".concat(appProps.currentLocale) : '';
    var LinkPrefixes = {
      'ReactiveCms::BlogPost': blogArchiveTranslation ? blogArchiveTranslation.slug : '',
      'ReactiveCms::BlogCategory': blogArchiveTranslation ? blogArchiveTranslation.slug : ''
    };
    if (itemTranslation) {
      if (itemTranslation.link) {
        var isAbsoluteUrl = new RegExp(/^https?\:\/\//i);
        if (isAbsoluteUrl.test(itemTranslation.link)) {
          return itemTranslation.link;
        }
        if (Object.keys(LinkPrefixes).indexOf(item.navigatableType) > -1) {
          var prefix = LinkPrefixes[item.navigatableType] || '';
          var link = itemTranslation.link && itemTranslation.link.length ? '/' + prefix + '/' + itemTranslation.link : '';
          return link.replace(/\/\/+/g, '/');
        }
        return linkWithLocale(itemTranslation.link, appProps);
      } else {
        return '';
      }
    }
  }
  return null;
}
function linkWithLocale(link, appProps) {
  if (link && (link.startsWith("/".concat(appProps.currentLocale, "/")) || link.startsWith("".concat(appProps.currentLocale, "/")))) {
    return link;
  } else {
    return "/".concat(appProps.currentLocale).concat(link && link.startsWith('/') ? '' : '/').concat(link);
  }
}